import { Link } from 'react-router-dom'
import { CSSProperties, PropsWithChildren } from 'react'
import { useTheme } from '@mui/material'

type Props = {
  to: string
  onClick?: () => void
  styles?: CSSProperties
}

export const NavLink = ({
  children,
  to,
  styles,
  ...props
}: PropsWithChildren & Props) => {
  const theme = useTheme()

  return (
    <Link
      to={to}
      style={{
        width: '100%',
        textDecoration: 'none',
        transition: 'all 0.3s ease-in-out',
        color: theme.palette.text.primary,
        textWrap: 'nowrap',
        ...styles,
      }}
      {...props}
    >
      {children}
    </Link>
  )
}
